import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IFooterLabel } from '../../models';
import { LanguageTranslationService } from '../../services/language-translation.service';
import { UserService } from '../../services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isLogin: boolean;
  footerTxt: IFooterLabel;
  envName: string = '';
  serverName: string | null = null;
  InstanceId: string | null = null;
  apiServerName: string = '';
  currentDateTime: Date = new Date();
  buildDate: Date | null = null;
  constructor(private userService: UserService, private languageTranslation: LanguageTranslationService, private http: HttpClient) {
    this.isLogin = this.userService.isAuthenticated();
     this.userService.isUserLoggedIn.subscribe(response => {
       this.isLogin = response;
      });
  }


  ngOnInit() {
    this.loadLanguageTranslationData();
    this.envName = environment.envName || 'UNKNOWN';
    this.serverName = localStorage.getItem('X-Server-Name');
    this.http.get<any>('assets/config.json').subscribe(x => {
      console.log(x.InstanceId);
      this.InstanceId = x.InstanceId;
    });
    this.http.get<any>('assets/build-info.json').subscribe(x => {
      this.buildDate = x.buildDate ? new Date(x.buildDate) : null;
    });
    setInterval(() => { this.currentDateTime = new Date(); }, 1000);
 
}
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "footerDisclosureLbl" },
      { controlName: "contactUsLbl" },
      { controlName: "FAQLbl" },
      { controlName: "kawneerComLbl" },
      { controlName: "legalNoticeLbl" },
      { controlName: "privacyPolicyLbl" },
      { controlName: "termsAndConditionsLbl" },
      { controlName: "copyRightLbl" },
      { controlName: "copyRightTxtLbl" },
    ];
    const componentName = "footer";
    const response = this.languageTranslation.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.footerTxt = response[response.length - 1];
    } else {
      this.footerTxt = response;
    }
  }

  //#endregion
  //#region Control Text
  
  footer = {
    footerDisclosureLbl: 'Due to the variance of laws and building and safety codes governing the design and use of glazed entrance, window and curtain wall products, seller does not assume responsibility for selections of product configurations, operating hardware or glazing materials.',
    contactUsLbl: 'CONTACT US',
    FAQLbl: 'FAQ',
    kawneerComLbl: 'KAWNEER.COM',
    legalNoticeLbl: 'LEGAL NOTICES',
    privacyPolicyLbl: 'PRIVACY POLICY',
    termsAndConditionsLbl: 'TERMS AND CONDITIONS',
    copyRightLbl: 'Copyright',
    copyRightTxtLbl: '2019-2020  Kawneer an Arconic Company. All rights reserved',
  }

  openTermsCondition() {
    window.open("../../../../assets/docs/termsandcondition.pdf");
  }

  //#endregion
}
